import axiosInstance from "../../utils/axios/axiosConfig";

// Content Types
export const listContentTypes = () => axiosInstance.get("/admin/content-types");
export const getContentType = (id) => axiosInstance.get(`/admin/content-types/${id}`);
export const createContentType = (payload) => axiosInstance.post("/admin/content-types", payload);
export const updateContentType = (id, payload) => axiosInstance.put(`/admin/content-types/${id}`, payload);
export const deleteContentType = (id) => axiosInstance.delete(`/admin/content-types/${id}`);

// Entries by slug
export const listEntriesBySlug = (slug) => axiosInstance.get(`/admin/content/${slug}/entries`);
export const upsertEntryBySlug = (slug, payload) => axiosInstance.post(`/admin/content/${slug}/entries`, payload);

export const updateEntry = (entryId, payload) => axiosInstance.put(`/admin/content-entries/${entryId}`, payload);
export const deleteEntry = (entryId) => axiosInstance.delete(`/admin/content-entries/${entryId}`);
export const publishEntry = (entryId) => axiosInstance.post(`/admin/content-entries/${entryId}/publish`);
export const unpublishEntry = (entryId) => axiosInstance.post(`/admin/content-entries/${entryId}/unpublish`);

// Media
// ✅ list media (library)
export const listMedia = ({ folder = "content", page = 1, q = "" } = {}) =>
  axiosInstance.get(`/admin/media?folder=${encodeURIComponent(folder)}&page=${page}&q=${encodeURIComponent(q)}`)

// ✅ upload media (to bunny) with folder
export const uploadMedia = (name, folder = "content" , image) => {
  const fd = new FormData()
  fd.append("image", image)
  fd.append("folder", folder)
  fd.append("name", name)

  return axiosInstance.post("/admin/media/upload", fd, { headers: { "Content-Type": "multipart/form-data" } })
}